import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAvatar = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "-0.5 -0.5 25 25",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.5,23.25V16.985A9.365,9.365,0,0,1,10.875.75c7.5,0,8.823,6.5,11.625,13.5h-3v3a3,3,0,0,1-3,3H15v3",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2
	})
});
export default SvgAvatar;
